export default __webpack_public_path__ + "static/media/Bracers of Black Oblivion.f95db16e.jpg";